import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './components/login/login.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'projects/shared/src/lib/shared.module';
import { LoginRoutingModule } from './login-routing.module';
import { PassKehilotComponent } from './components/pass-kehilot/pass-kehilot.component';
import { LoginFooterComponent } from './components/login-footer/login-footer.component';
import { LoginBySessionComponent } from './components/login-by-session/login-by-session.component';
import { NewUserComponent } from './components/new-user/new-user.component';
import { LoginButtonsComponent } from './components/login-buttons/login-buttons.component';
import { LoginIconsComponent } from './components/login-icons/login-icons.component';
import { LoginPanelComponent } from './components/login-panel/login-panel.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { VendorsModule } from 'vendors';
import { NewSiteAddComponent } from './components/login/new-site-add/new-site-add.component';
import { ConcatUsModule } from '../concat-us/contact-us.module';

@NgModule({
  imports: [
    CommonModule, FormsModule, LoginRoutingModule, SharedModule.forRootOrChild(), VendorsModule.forRootOrChild(),ConcatUsModule
  ],
  declarations: [LoginComponent, PassKehilotComponent, LoginFooterComponent, LoginBySessionComponent, NewUserComponent, LoginButtonsComponent, LoginIconsComponent, LoginPanelComponent, ChangePasswordComponent, NewSiteAddComponent],
})
export class LoginModule { }

